export default __webpack_public_path__ + "static/media/career-bonus.88fcd52e.png";